export default () => {
  const shop = document.getElementById('menu-item-22')
  const dropdown = document.querySelector('.dropdown')
  const dropdownChildren = document.querySelectorAll('.dropdown, .dropdown *')

  let hover = false
  let timer = null
  const cancelTimer = () => {
    window.clearTimeout(timer)
  }
  const startTimer = () => {
    window.clearTimeout(timer)
    timer = window.setTimeout(() => dropdown.classList.remove('dropit'), 700)
  }
  const update = () => {
    if (hover) {
      cancelTimer()
      return dropdown.classList.add('dropit')
    }
    if (!hover) {
      startTimer()
    }
  }

  shop.addEventListener('mouseenter', function() {
    hover = true
    update()
  })
  shop.addEventListener('mouseout', function() {
    hover = false
    update()
  })
  dropdownChildren.forEach(el =>
    el.addEventListener('mouseenter', function() {
      hover = true
      update()
    })
  )
  dropdownChildren.forEach(el =>
    el.addEventListener('mouseout', function() {
      hover = false
      update()
    })
  )
}



// WEBPACK FOOTER //
// ./src/js/_dropdown.js